// extracted by mini-css-extract-plugin
module.exports = {"a":"table2phone_a__thcw3","aa":"table2phone_aa__BdJbh","aat":"table2phone_aat__T1OLa"};